export default __webpack_public_path__ + "899ce8647f2f4d75b233ea24037eb7fa.png";